import { useEffect } from 'react';
import { usePageMetadata } from '../contexts/PageMetadataContext';

interface PageTitleOptions {
  description?: string;
  backUrl?: string;
  helpContentKey?: string;
}

/**
 * Hook to set page title, description, and back URL in the layout header.
 * @param title - The page title to display
 * @param optionsOrDescription - Optional string description (legacy) or options object
 */
export const usePageTitle = (title: string, optionsOrDescription?: string | PageTitleOptions) => {
  const { setPageMetadata } = usePageMetadata();

  const options: PageTitleOptions = typeof optionsOrDescription === 'string'
    ? { description: optionsOrDescription }
    : (optionsOrDescription ?? {});

  const { description, backUrl, helpContentKey } = options;

  useEffect(() => {
    setPageMetadata({ title, description, backUrl, helpContentKey });
    return () => { setPageMetadata(null); };
  }, [title, description, backUrl, helpContentKey, setPageMetadata]);
};
